import { render, staticRenderFns } from "./RideDocumentsPanel.vue?vue&type=template&id=b0bfd3be&scoped=true"
import script from "./RideDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./RideDocumentsPanel.vue?vue&type=script&lang=js"
import style0 from "./RideDocumentsPanel.vue?vue&type=style&index=0&id=b0bfd3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bfd3be",
  null
  
)

export default component.exports